// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ae1a232b","455":"a0dd6d37"}[chunkId] + ".chunk.js";
};